function asNonEmptyString(value) {
    if (typeof value !== "string") return null;
    const trimmed = value.trim();
    return trimmed || null;
}

function hostFromUrl(url) {
    try {
        return new URL(url).hostname;
    } catch (_err) {
        return "link";
    }
}

export function buildLinkMetadataUrl(targetUrl) {
    const base = process.env.REACT_APP_LINK_METADATA_URL || "/api/link-metadata";
    const separator = base.includes("?") ? "&" : "?";
    return `${base}${separator}url=${encodeURIComponent(targetUrl)}`;
}

export function normalizeLinkMetadata(payload, fallbackUrl) {
    const src = payload && typeof payload === "object" ? payload : {};

    const title = asNonEmptyString(src.title)
        || asNonEmptyString(src.ogTitle)
        || asNonEmptyString(src.metaTitle)
        || fallbackUrl;

    const description = asNonEmptyString(src.description)
        || asNonEmptyString(src.ogDescription)
        || asNonEmptyString(src.metaDescription)
        || fallbackUrl;

    const siteName = asNonEmptyString(src.siteName)
        || asNonEmptyString(src.ogSiteName)
        || asNonEmptyString(src.domain)
        || hostFromUrl(fallbackUrl);

    return {
        title,
        description,
        siteName,
    };
}

